// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Js_math = require("@rescript/std/lib/js/js_math.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Type_Common = require("./Type_Common.bs.js");
var Type_String = require("./Type_String.bs.js");
var Type_Sticker = require("./Type_Sticker.bs.js");

function status_encode(v) {
  if (v) {
    return ["NotFavorite"];
  } else {
    return ["Favorite"];
  }
}

function status_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Favorite" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Favorite */0
                  };
          }
      case "NotFavorite" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotFavorite */1
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function t_encode(v) {
  if (v) {
    return [
            "Available",
            status_encode(v._0)
          ];
  } else {
    return ["NotAvailable"];
  }
}

function t_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Available" :
          if (tagged.length !== 2) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = status_decode(Belt_Array.getExn(json_arr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Available */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotAvailable" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotAvailable */0
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

var Favorite = {
  status_encode: status_encode,
  status_decode: status_decode,
  t_encode: t_encode,
  t_decode: t_decode
};

function fromStickers(stickers) {
  var match = stickers.topLeft;
  if (match === undefined) {
    return "Standard";
  }
  if (typeof match !== "object") {
    if (match === "PrimeTime") {
      return "PrimeTime";
    } else {
      return "Standard";
    }
  }
  var variant = match.NAME;
  if (variant === "Direct") {
    return "Direct";
  } else if (variant === "Live") {
    return "Live";
  } else {
    return "Standard";
  }
}

function view(t) {
  return t;
}

var Kind = {
  fromStickers: fromStickers,
  view: view,
  standard: "Standard"
};

function resolution_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "url",
                    false,
                    Type_String.Href.t_encode(v.url)
                  ],
                  [
                    "w",
                    false,
                    Spice.intToJson(v.w)
                  ],
                  [
                    "h",
                    false,
                    Spice.intToJson(v.h)
                  ]
                ]));
}

function resolution_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Type_String.Href.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var w = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "w"), null));
    if (w.TAG === /* Ok */0) {
      var h = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "h"), null));
      if (h.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  w: w._0,
                  h: h._0
                }
              };
      }
      var e = h._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".h" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = w._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".w" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function makeResolution(url, width, height) {
  return {
          url: Curry._1(Type_String.Href.make, url),
          w: width,
          h: height
        };
}

function getSubtitleDsStyle(titleStyle, subtitleStyle, style) {
  if (style) {
    return subtitleStyle;
  } else {
    return titleStyle;
  }
}

function computeDuration(duration) {
  return Js_math.ceil(duration / 60);
}

function getTimeProgression(progression) {
  return Type_Common.Progression.getTime(progression);
}

function getDurationLabel(minutesLabel, duration) {
  var durationInMinutes;
  durationInMinutes = duration.TAG === /* Minute */0 ? duration._0 : computeDuration(duration._0);
  return durationInMinutes.toString() + (" " + minutesLabel);
}

function addDurationSticker(durationLabel, teaserKind, stickers) {
  if (typeof teaserKind !== "object" && (teaserKind === "Live" || teaserKind === "Direct")) {
    return stickers;
  }
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.map(durationLabel, Type_String.Teaser.DurationLabel.toString), (function (param) {
                    return Type_Sticker.addTimeSticker(stickers, param);
                  })), stickers);
}

function addClubDurationSticker(transformDuration, duration, teaserKind, stickers) {
  if (typeof teaserKind !== "object" && (teaserKind === "Live" || teaserKind === "Direct" || teaserKind === "PrimeTime")) {
    return stickers;
  }
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.map(duration, transformDuration), (function (param) {
                    return Type_Sticker.addTimeSticker(stickers, param);
                  })), stickers);
}

function makeDsId(programId, teaserId) {
  if (programId !== undefined) {
    return programId;
  } else if (teaserId !== undefined) {
    return teaserId;
  } else {
    return Uuid.v4();
  }
}

function makeKey(zoneId, dsId) {
  return Curry._1(Type_String.Teaser.Key.make, zoneId !== undefined ? (
                dsId !== undefined ? Curry._1(Type_String.Zone.Id.toString, zoneId) + Curry._1(Type_String.Teaser.DsId.toString, dsId) : Uuid.v4()
              ) : (
                dsId !== undefined ? Curry._1(Type_String.Teaser.DsId.toString, dsId) : Uuid.v4()
              ));
}

function extractTitle(teaser) {
  var match = teaser.title;
  if (match !== undefined) {
    return match._0;
  }
  
}

function titleToString(title) {
  return Curry._1(Type_String.Teaser.Title.toString, title._0);
}

function extractSubtitleString(subtitle) {
  if (subtitle !== undefined) {
    return subtitle._0;
  }
  
}

var Helper = {
  computeDuration: computeDuration,
  getTimeProgression: getTimeProgression,
  getDurationLabel: getDurationLabel,
  addDurationSticker: addDurationSticker,
  addClubDurationSticker: addClubDurationSticker,
  makeDsId: makeDsId,
  makeKey: makeKey,
  extractTitle: extractTitle,
  titleToString: titleToString,
  extractSubtitleString: extractSubtitleString
};

exports.Favorite = Favorite;
exports.Kind = Kind;
exports.resolution_encode = resolution_encode;
exports.resolution_decode = resolution_decode;
exports.makeResolution = makeResolution;
exports.getSubtitleDsStyle = getSubtitleDsStyle;
exports.Helper = Helper;
/* uuid Not a pure module */
